import { AnyAction, configureStore, EnhancedStore } from "@reduxjs/toolkit";
import { ThunkMiddlewareFor } from "@reduxjs/toolkit/dist/getDefaultMiddleware";
import authenticationSlice from "../reducer/authentication-slice";
import bookingSlice from "../reducer/booking-slice";
import searchedDataSlice from "../reducer/searched-data-slice";
import costingSlice from "../reducer/costing-slice";
import filterSlice from "../reducer/filter-slice";

const store: EnhancedStore<any, AnyAction, [ThunkMiddlewareFor<any>]> =
  configureStore({
    reducer: {
      authenticationSlice,
      bookingSlice,
      costingSlice,
      searchedDataSlice,
      filterSlice
    },
  });

export default store;
